// extracted by mini-css-extract-plugin
module.exports = {"trialContainer":"style_trialContainer__08xEd","trialCourseContent":"style_trialCourseContent__3hpVK"};